// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import { StyleSheet } from "react-native-web";
import colors from "../config/colors";
import fonts from "../config/fonts";
const LoginScreenStyle = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.green,
    justifyContent: "center",
    alignItems: "center",
  },
  eyeIcon: {
    position: "absolute",
    right: 20, 
    top: 10, 
  },
  logo: {
    position: "absolute",
    top: 50,
    left: 20,
    width: 105,
    height: 50,
  },
  form: {
    width: "80%",
    backgroundColor: colors.green,
    borderRadius: 16,
    padding: 24,
    alignItems: "center",
  },
  button: {
    backgroundColor: colors.white,
    padding: 12,
    borderRadius: 8,
    marginTop: 16,
    width: "50%",
    alignItems: "center",
  },
  buttonText: {
    color: colors.green,
    fontSize: 18,
    fontWeight: "bold",
    fontFamily: fonts.regular,
  },
  forgotPassword: {
    marginTop: 16,
  },
  forgotPasswordText: {
    fontSize: 16,
    fontFamily: fonts.regular,
  },
  error: {
    color: "red",
    fontFamily: fonts.regular,
  },
});

export default LoginScreenStyle;
